import { createNote } from '@/api/school';
import { Role } from '@/utils/auth';

const ClassEditor = () => import(/* webpackChunkName:"group-editor"   */ '@/components/creator-school/ClassEditor.vue');
const ModuleEditor = () => import(/* webpackChunkName:"group-editor"   */ '@/components/creator-school/ModuleEditor.vue');
const NoteEditor = () => import(/* webpackChunkName:"group-editor"   */ '@/components/creator-school/NoteEditor.vue');
const NoteView = () => import(/* webpackChunkName:"group-dashboard"   */ '@/pages/NoteView.vue');

export default [
  {
    path: '/class/:id',
    name: 'ClassEditor',
    component: ClassEditor,
    props: true,
    meta: {
      allowed: [Role.ADMIN],
    },
  },
  {
    path: '/module/:id',
    name: 'ModuleEditor',
    component: ModuleEditor,
    props: true,
    meta: {
      allowed: [Role.ADMIN],
    },
  },
  {
    path: '/notes/create',
    name: 'NoteCreate',
    async beforeEnter(to, from, next) {
      try {
        const { data } = await createNote(to.query);
        next({
          name: 'NoteEditor',
          params: {
            id: data.id,
          },
        });
      } catch {
        next({ name: 'Homepage' });
      }
    },
  },
  {
    path: '/notes/:id',
    name: 'NoteView',
    component: NoteView,
    props: true,
  },
  {
    path: '/notes/:id/edit',
    name: 'NoteEditor',
    component: NoteEditor,
    props: true,
  },
];
